export class Belt{
    BeltId:any;
    BeltName:any;
    BeltVersion:any;
    CreatedBy:any;
    CreatedDate:any;
    ModifiedBy:any;
    ModifiedDate:any;
    IsActive:any;
}